// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shop-item[data-v-3c900ab4] {\n  margin-bottom: 16px;\n  font-size: 1rem;\n}\n.shop-item .rankIndex[data-v-3c900ab4] {\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  vertical-align: middle;\n}\n[data-v-3c900ab4] .ant-result {\n  margin-top: 80px;\n}\n[data-v-3c900ab4] .ant-result-title {\n  font-size: 20px;\n}", ""]);
// Exports
module.exports = exports;
